import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const RussiaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'RU',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Russia',
  SHORT_NAME: 'BE',

  DISPLAY_NAME: 'Russia (English)',
  DISPLAY_COUNTRY: 'Russia',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.com/ru/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  POSTCODE_FORMAT: /[0-9]{6}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
}

export default RussiaLocale
